<script>
  import '../app.css';
  import { dev } from '$app/environment';
  import { beforeNavigate } from '$app/navigation';
  import ToastContainer from '$lib/ToastContainer.svelte';

  let { children } = $props();

  // In dev, the inventory app runs on its own Vite server (localhost:5174)
  // under the /inventory base path, so we bounce any /inventory navigation
  // cross-origin instead of letting it 404 here.
  beforeNavigate((nav) => {
    if (!dev || !nav.to) {
      return;
    }
    const url = nav.to.url;
    if (!url.pathname.startsWith('/inventory')) {
      return;
    }
    nav.cancel();
    window.location.href = `http://localhost:5174${url.pathname}${url.search}${url.hash}`;
  });
</script>

{@render children()}

<ToastContainer />
